// removed by extract-text-webpack-plugin
module.exports = {"barEchart":"score_barEchart_MgZBx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/financialOverview/score.scss
// module id = 1565
// module chunks = 0